import { render } from "./OldHomeView.vue?vue&type=template&id=7234f126"
import script from "./OldHomeView.vue?vue&type=script&lang=js"
export * from "./OldHomeView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__